module.exports = __webpack_public_path__ + "static/img/Rise.95560bfd.svg";